import script from "./RtbStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./RtbStatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./RtbStatusBadge.vue?vue&type=style&index=0&id=27928014&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27928014"]])

export default __exports__